import { Component, computed } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ProgressSpinnerModule } from "primeng/progressspinner";
import { LoadingService } from "../../services/loading.service";

@Component({
  selector: "app-loading-spinner",
  standalone: true,
  imports: [CommonModule, ProgressSpinnerModule],
  template: `
    <div
      *ngIf="showSpinner()"
      class="fixed top-0 left-0 w-full h-full flex items-center justify-center bg-black bg-opacity-30 z-50"
    >
      <p-progressSpinner
        styleClass="w-16 h-16"
        strokeWidth="4"
        animationDuration=".5s"
      />
    </div>
  `,
  styles: `
    :host {
      display: contents;
    }
  `,
})
export class LoadingSpinnerComponent {
  constructor(private readonly loadingService: LoadingService) {}

  /**
   * Computed signal that returns whether the spinner should be shown
   */
  protected showSpinner = computed(() => this.loadingService.loading());
}
